"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CarouselMixin = void 0;
var _styledComponents = require("styled-components");
var _CarouselNavControls = require("../../components/CarouselNavControls/CarouselNavControls.styles");
var _CarouselSlide = require("../../components/CarouselSlide/CarouselSlide.styles");
/** @class CarouselMixin */
/** @method */
var CarouselMixin = /*#__PURE__*/(0, _styledComponents.css)(["position:relative;", " + ", "{margin-top:0;}", "{display:none;}@media (hover:hover) and (pointer:fine){", "{display:flex;}}"], _CarouselSlide.StyledCarouselSlide, _CarouselSlide.StyledCarouselSlide, _CarouselNavControls.StyledCarouselNavControls, _CarouselNavControls.StyledCarouselNavControls);
exports.CarouselMixin = CarouselMixin;